var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "comments-input-wrapper" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.message,
          expression: "message",
        },
      ],
      staticClass: "comments-input",
      attrs: {
        type: "text",
        placeholder: _vm.$t("addComment"),
        "aria-label": _vm.$t("addComment"),
      },
      domProps: { value: _vm.message },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.message = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "comments-send-comment-button",
        attrs: { type: "submit", "aria-label": _vm.$t("send") },
        on: { click: _vm.addMessage },
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("send")) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }